import { apiSlice } from "../api/apiSlice";

export const assignmentMarkApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		submitAssignment: builder.mutation({
			query: (data) => ({
				url: "/assignmentMark",
				method: "POST",
				body: data,
			}),
		}),
		getAssignmentMarks: builder.query({
			query: () => "/assignmentMark",
		}),
		updateAssignmentMark: builder.mutation({
			query: ({ id, mark }) => ({
				url: `/assignmentMark/${id}`,
				method: "PATCH",
				body: {
					mark: mark,
					status: "published",
				},
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				// update optismatically
				const patchResult = dispatch(
					apiSlice.util.updateQueryData(
						"getAssignmentMarks",
						undefined,
						(draft) => {
							let markToUpdate = draft.find(
								(mark) => mark.id == arg.id
							);
							if (markToUpdate) {
								markToUpdate.mark = arg.mark;
								markToUpdate.status = "published";
							}
						}
					)
				);

				try {
					await queryFulfilled;
				} catch (error) {
					patchResult.undo();
				}
			},
		}),
		getAssignmentMarkByStudentIdAndAssignmentId: builder.query({
			query: ({ studentId, assignmentId }) =>
				`/assignmentMark?student_id=${studentId}&assignment_id=${assignmentId}`,
		}),
	}),
});

export const {
	useGetAssignmentMarksQuery,
	useSubmitAssignmentMutation,
	useGetAssignmentMarkByStudentIdAndAssignmentIdQuery,
	useUpdateAssignmentMarkMutation,
} = assignmentMarkApi;
